import React, { useEffect } from "react";
import Modal from "./modal";
import Confirm from "./confirm";
import { getString } from "../../utilities";
import { mpModalClicked, mpModalShown } from "../../utilities/mixpanel";
import { useLocation } from "react-router";

export default function LeavingSiteModal({ doShow, cancelFunction, url }) {
  const location = useLocation();
  const modalEventData = {
    modalType: "confirm-leaving-site",
    triggerType: "button click",
    header: getString("attention.0"),
    primaryCta: getString("continue.0"),
    secondaryCta: "none",
    tertiaryCta: "none",
    isDismissible: true,
    pathname: location.pathname,
  };

  useEffect(() => {
    if (doShow) {
      mpModalShown(modalEventData);
    }
  }, [doShow]);

  return (
    <Modal doShow={doShow} closeOnEscape={cancelFunction}>
      <Confirm
        confirm={() => {
          // Mixpanel event
          mpModalClicked({
            ...modalEventData,
            interaction: "primary cta",
          });

          // close the door(modal) behind you
          cancelFunction();

          window.open(url, "_blank", "noopener,noreferrer");
        }}
        cancel={() => {
          // Mixpanel event
          mpModalClicked({
            ...modalEventData,
            interaction: "dismissed",
          });

          cancelFunction();
        }}
        button={getString("continue.0")}
        cancelButton={getString("cancel.4")}
      >
        <div className="modal-content-header">{getString("attention.0")}</div>
        <div className="leaving-modal">
          <p>{getString("leaving.message")}</p>
          <p>{getString("leaving.cta")}</p>

          <p className="leaving-modal-disclaimer">{getString("leaving.disclaimer")}</p>
        </div>
      </Confirm>
    </Modal>
  );
}
